import { BRAND } from '../../../constants'

const CloseTitle = ({ title }: { title: string }) => {
  return (
    <div>
      <section className='standfirst' id='stand-first'>
        <h5 className='title'>{title}</h5>
      </section>
      <style jsx>{`
        .close {
          font-size: 0px;
          cursor: pointer;
        }
        .standfirst {
          width: 0px;
        }
        .title {
          font-size: 0px;
        }
        @media screen and (max-width: ${BRAND.media.small}px) {
          .standfirst {
            display: flex;
            flex-direction: row;
            width: 240px;
            justify-content: space-between;
            align-items: center;
          }
          .close {
            padding-bottom: 6px;
            font-size: 18px;
          }
          .title {
            color: ${BRAND.primaryColour};
            font-weight: 600;
            margin-bottom: 12px;
            font-size: 18px;
            line-height: 24px;
          }
        }
      `}</style>
    </div>
  )
}

export default CloseTitle
